import { icon, type IconName } from "./icons";
import type { CustomizeGridContent } from "../i18n/types";

/** Card variants and icons — structural, zipped with the card content
 * in the dictionary. The middle card is the highlighted one. */
const CARD_META = [
  { variant: "blue", iconName: "shield" as IconName },
  { variant: "purple", iconName: "sparkle" as IconName },
  { variant: "green", iconName: "lock" as IconName },
] as const;

export function renderCustomizeGrid(t: CustomizeGridContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section";
  root.id = "security";
  root.innerHTML = `
    <div class="page">
      <div class="section-head section-head--center" data-reveal>
        <h2 class="section__title">${t.title}</h2>
        <p class="section__lead">
          ${t.lead}
        </p>
      </div>
      <div class="cards3">
        ${t.cards.map((c, i) => `
          <div class="card3 card3--${CARD_META[i].variant} ${i === 1 ? "card3--highlight" : ""}" data-reveal style="--reveal-delay:${i * 80}ms">
            <div class="card3__icon">${icon[CARD_META[i].iconName]({ size: 22 })}</div>
            <h3 class="card3__title">${c.title}</h3>
            <p class="card3__body">${c.body}</p>
          </div>
        `).join("")}
      </div>
    </div>
  `;
  return root;
}
